import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { galleryDetails } from "../../utils/gallery-details";
import Icons from "../common/components/Icons";
import Paragraph from "../common/ui/Paragraph";
import Heading from "../common/ui/Heading";
import Cta from "../common/ui/Cta";
const Gallery = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const currentPage = Number(searchParams.get("page")) || 1;
  const itemsPerPage = 12;
  const totalPages = Math.ceil(galleryDetails.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedItems = galleryDetails.slice(
    startIndex,
    startIndex + itemsPerPage
  );
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      navigate(`?page=${newPage}`);
      const parent = document.getElementById("gallery-top");
      if (parent) {
        parent.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
  };

  const [flipped, setFlipped] = useState(-1);

  const handleFlip = (index) => {
    setFlipped(index);
  };
  return (
    <>
      <div className="py-10 sm:py-12 md:py-14 lg:py-[60px]">
        <div className="flex flex-wrap -mx-2 md:-mx-3 gap-y-4 md:gap-y-6">
          {paginatedItems.map((obj, index) => (
            <div
              onMouseOver={() => handleFlip(index)}
              onMouseLeave={() => handleFlip(-1)}
              key={index}
              className="px-2 md:px-3  w-full sm:w-6/12 md:w-4/12 flip-container">
              <div className="overflow-clip aspect-square rounded-xl">
                <div
                  className={`relative aspect-square group cursor-pointer hover:shadow-custom-gray-v4/50 shadow-[0_0_20px_0_transparent] flip-inner ${
                    flipped === index ? "flipped" : ""
                  }`}>
                  <img
                    src={obj.url}
                    className="absolute flip-front top-0 left-0 h-full w-full object-cover group-hover:scale-105"
                    onError={(e) => (e.currentTarget.style.display = "none")}
                    alt="gallery content"
                  />{" "}
                  <div className="flip-back absolute border border-solid border-custom-blue-v2 bg-white top-0 h-full w-full p-3 rounded-xl overflow-auto">
                    <Heading
                      variant="secondary"
                      className=" !text-sm sm:!text-xl">
                      Lorem ipsum dolor sit amet.
                    </Heading>

                    <Paragraph className="mt-3 max-sm:text-xs">
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Molestias enim impedit deleniti labore nulla nobis
                      blanditiis officiis alias assumenda veritatis.
                    </Paragraph>
                    <Paragraph className="my-3 max-sm:text-xs">
                      Lorem ipsum dolor sit amet consectetur adipisicing elit.
                      Molestias enim impedit deleniti labore nulla nobis
                      blanditiis officiis alias assumenda veritatis.
                    </Paragraph>
                    <Cta className="max-sm:px-3 max-sm:text-xs max-sm:py-1 mt-4">
                      Reade More
                    </Cta>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="flex items-center gap-x-3 justify-center">
        <div
          className={`size-8 md:size-[42px] border border-solid border-custom-blue-v2 rounded-lg flex items-center justify-center group 
            ${
              currentPage === 1
                ? "opacity-40 pointer-events-none"
                : "cursor-pointer hover:bg-custom-blue-v2"
            }`}
          onClick={() => handlePageChange(currentPage - 1)}>
          <Icons
            icon="pagination-arrow"
            className={`group-hover:stroke-white !duration-100  max-md:size-6 ${
              currentPage === 1 ? "pointer-events-none" : ""
            }`}
          />
        </div>
        {[...Array(totalPages)].map((_, index) => {
          const pageNumber = index + 1;
          return (
            <div
              key={pageNumber}
              onClick={() => handlePageChange(pageNumber)}
              className={`size-8 md:size-[42px] rounded-lg flex items-center justify-center  !leading-150 text-base md:text-xl font-medium border border-solid border-custom-blue-v2
                ${
                  currentPage !== pageNumber
                    ? "cursor-pointer text-custom-blue-v2 hover:bg-custom-blue-v2/80 hover:text-white "
                    : "hover:bg-opacity-50 bg-custom-blue-v2  text-white pointer-events-none"
                }`}>
              {pageNumber}
            </div>
          );
        })}
        <div
          className={`size-8 md:size-[42px] border border-solid border-custom-blue-v2 rounded-lg flex items-center justify-center rotate-180 group
            ${
              currentPage === totalPages
                ? "opacity-40 pointer-events-none"
                : "cursor-pointer hover:bg-custom-blue-v2"
            }`}
          onClick={() => handlePageChange(currentPage + 1)}>
          <Icons
            icon="pagination-arrow"
            className={`group-hover:stroke-white !duration-100 max-md:size-6 ${
              currentPage === totalPages ? "pointer-events-none" : ""
            }`}
          />
        </div>
      </div>
    </>
  );
};
export default Gallery;
